// src/app/features/toronto/toronto-routing.module.ts
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TorontoDashboardComponent} from './components/dashboard/toronto-dashboard.component';
import {TorontoListingDetailsFullComponent} from './components/listing-details/toronto-listing-details-full.component';

const routes: Routes = [
  {path: '', component: TorontoDashboardComponent},
  {path: 'fulldetails/:addressStr/:cityStr/:MLSNum', component: TorontoListingDetailsFullComponent},
  {path: 'fulldetails/:MLSNum', component: TorontoListingDetailsFullComponent},
  {path: ':addressStr/:cityStr/:MLSNum', component: TorontoListingDetailsFullComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TorontoRoutingModule {
}
